import React from 'react';
import {
  Text as RNText,
  TextInput as RNTextInput,
  StyleSheet,
  TextProps,
  TextInputProps,
} from 'react-native';

// React 19 + RN 0.86'da global `Text.render` yaması çalışmıyor; onun yerine Text
// ve TextInput'u sarıp fontu doğrudan uyguluyoruz. Özel fontta fontWeight tek
// başına aileler arasında geçiş yapmadığı için her ağırlığı Inter ailesine eşliyoruz.
const WEIGHT_TO_FAMILY: Record<string, string> = {
  normal: 'Inter_400Regular',
  '100': 'Inter_400Regular',
  '200': 'Inter_400Regular',
  '300': 'Inter_400Regular',
  '400': 'Inter_400Regular',
  '500': 'Inter_500Medium',
  '600': 'Inter_600SemiBold',
  bold: 'Inter_700Bold',
  '700': 'Inter_700Bold',
  '800': 'Inter_700Bold',
  '900': 'Inter_700Bold',
};

function fontFamilyForStyle(style: unknown): string {
  const flat = (StyleSheet.flatten(style as any) || {}) as { fontWeight?: string | number };
  return WEIGHT_TO_FAMILY[String(flat.fontWeight ?? 'normal')] || 'Inter_400Regular';
}

export const Text = React.forwardRef<any, TextProps>(({ style, ...props }, ref) => (
  <RNText ref={ref} {...props} style={[{ fontFamily: fontFamilyForStyle(style) }, style]} />
));

export const TextInput = React.forwardRef<any, TextInputProps>(({ style, ...props }, ref) => (
  <RNTextInput ref={ref} {...props} style={[{ fontFamily: fontFamilyForStyle(style) }, style]} />
));
